module.exports = __webpack_public_path__ + "static/media/bts_veld_170805_005_small.f7eadab2.jpg";